module.exports = __webpack_public_path__ + "assets/img/11_753.d3e71f8d.jpg";